import PropTypes from "prop-types";
import React from "react";

import { createClassNameString } from "@/utils/createClassNameString";

import { Button } from "../Button";
import { Image } from "../Image";

import "./styles.scss";

export const Chip = ({ className, label, onClick, ...props }) => (
  <div className={createClassNameString(["apti-CL apti-Chip", className])} {...props}>
    <Button className="apti-Chip--button" onClick={onClick}>
      <Image alt="X" className="apti-Chip--icon" data-label={label} src="icons/delete_button.svg" />
    </Button>
    <label className="apti-Chip--label">{label}</label>
  </div>
);

Chip.propTypes = {
  className: PropTypes.string,
  label: PropTypes.string.isRequired,
  onClick: PropTypes.func.isRequired,
};

Chip.defaultProps = {
  className: undefined,
  label: "",
  onClick: () => {},
};
